var map = {
	"./App": 39,
	"./App.js": 39,
	"./AppWebSocket": 17,
	"./AppWebSocket.js": 17,
	"./Board": 19,
	"./Board.js": 19,
	"./SettingsModal": 18,
	"./SettingsModal.js": 18
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;